<template>
  <transition name="login-swap" mode="out-in">
    <div v-if="gravatarUrl" key="gravatar" class="mb-3 d-flex flex-column align-center" style="gap: 6px;">
      <div style="border-radius: 50%; border: 2px solid #f9f9f9;">
        <v-avatar size="100">
          <img :src="gravatarUrl" :alt="login" />
        </v-avatar>
      </div>
      <span style="font-size: 14px; font-weight: 500;">{{ displayName || login }}</span>
      <v-btn text x-small color="grey" @click="$emit('forget')">
        {{ $t('login.label.not_you') }}
      </v-btn>
    </div>

    <v-text-field
        v-else
        key="username-field"
        required outlined dense hide-details class="mb-3"
        name="login"
        :label="$t('login.label.username')"
        type="text"
        autocomplete="username"
        :disabled="disabled"
        :value="login"
        :clearable="true"
        @input="$emit('update:login', $event)"
        @keyup.enter="$emit('keyup-enter')"
    ></v-text-field>
  </transition>
</template>

<script>
export default {
  name: 'LoginUserAvatar',
  props: {
    gravatarUrl: { type: String, default: null },
    displayName: { type: String, default: null },
    login: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
}
</script>

<style lang="scss" scoped>
.login-swap-enter-active,
.login-swap-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}
.login-swap-enter {
  opacity: 0;
  transform: translateY(-6px);
}
.login-swap-leave-to {
  opacity: 0;
  transform: translateY(6px);
}
</style>
